export default "__VITE_ASSET__DIavvCVL__"